import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSearch, FiInfo } = FiIcons;

const DimensionSearch = ({ onSearch }) => {
  const [dimensions, setDimensions] = useState({
    inner_diameter: '',
    outer_diameter: '',
    width: ''
  });
  const [tolerance, setTolerance] = useState(0.1);

  const handleInputChange = (field, value) => {
    setDimensions(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearch = () => {
    const filters = {
      dimensions: {}
    };

    Object.entries(dimensions).forEach(([key, value]) => {
      if (value) {
        const numValue = parseFloat(value);
        filters.dimensions[`${key}_mm`] = {
          min: numValue - tolerance,
          max: numValue + tolerance
        };
      }
    });

    onSearch(filters);
  };

  const parseInput = (input) => {
    // Regex für Formate wie "25x47x7", "25 x 47 x 7", "25*47*7"
    const match = input.match(/(\d+(?:\.\d+)?)\s*[xX*×]\s*(\d+(?:\.\d+)?)\s*[xX*×]\s*(\d+(?:\.\d+)?)/);
    if (match) {
      setDimensions({
        inner_diameter: match[1],
        outer_diameter: match[2],
        width: match[3]
      });
    }
  };

  return (
    <motion.div
      className="space-y-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {/* Quick Input */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Schnelleingabe (Format: 25x47x7)
        </label>
        <input
          type="text"
          placeholder="z.B. 25x47x7 oder 25 x 47 x 7"
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
          onChange={(e) => parseInput(e.target.value)}
        />
      </div>

      <div className="text-center text-gray-500 text-sm">oder einzeln eingeben</div>

      {/* Individual Dimensions */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Innendurchmesser (mm)
          </label>
          <input
            type="number"
            step="0.1"
            value={dimensions.inner_diameter}
            onChange={(e) => handleInputChange('inner_diameter', e.target.value)}
            placeholder="z.B. 25"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Außendurchmesser (mm)
          </label>
          <input
            type="number"
            step="0.1"
            value={dimensions.outer_diameter}
            onChange={(e) => handleInputChange('outer_diameter', e.target.value)}
            placeholder="z.B. 47"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Breite/Höhe (mm)
          </label>
          <input
            type="number"
            step="0.1"
            value={dimensions.width}
            onChange={(e) => handleInputChange('width', e.target.value)}
            placeholder="z.B. 7"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors"
          />
        </div>
      </div>

      {/* Tolerance Setting */}
      <div className="flex items-center space-x-4">
        <label className="text-sm font-medium text-gray-700">
          Toleranz: ±{tolerance}mm
        </label>
        <input
          type="range"
          min="0.01"
          max="1"
          step="0.01"
          value={tolerance}
          onChange={(e) => setTolerance(parseFloat(e.target.value))}
          className="flex-1 accent-red-600"
        />
        <input
          type="number"
          step="0.01"
          min="0.01"
          max="1"
          value={tolerance}
          onChange={(e) => setTolerance(parseFloat(e.target.value) || 0.1)}
          className="w-20 px-2 py-1 border border-gray-300 rounded text-sm focus:ring-red-500 focus:border-red-500"
        />
      </div>

      {/* Search Button */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2 text-sm text-gray-600">
          <SafeIcon icon={FiInfo} className="w-4 h-4" />
          <span>Die Suche findet Komponenten im angegebenen Toleranzbereich</span>
        </div>
        <button
          onClick={handleSearch}
          className="flex items-center space-x-2 bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors font-medium shadow-sm"
        >
          <SafeIcon icon={FiSearch} className="w-5 h-5" />
          <span>Suchen</span>
        </button>
      </div>
    </motion.div>
  );
};

export default DimensionSearch;